import React from 'react'
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Link,
} from 'react-router-dom'
import logo from './logo.svg'
import './App.css'
import MoviesList from './MoviesList'
import MovieDetail from './MovieDetail'
// a4f92f085fc7a3c8549a0d224c44cdf9


const App = () => (
    <Router>
        <div className="App">
            <header className="App-header">
                <Link to="/">
                    <img src={logo} className="App-logo" alt="logo" />
                </Link>

            </header>
            <Switch>
                <Route exact path="/" component={MoviesList} />
                <Route path="/:id" component={MovieDetail} />
            </Switch>
        </div>
    </Router>
)


export default App
